import Icon from '../components/Icon.vue'

Icon.register({
  'vote-yea': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M608 320c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-576c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h64v64h-22.4c-5.3 0-9.6 3.6-9.6 8v16c0 4.4 4.3 8 9.6 8h492.8c5.3 0 9.6-3.6 9.6-8v-16c0-4.4-4.3-8-9.6-8h-22.4v-64h64zM512 384h-384v-319.7c0-17.8 14.5-32.3 32.4-32.3h319.3c17.8 0 32.3 14.4 32.3 32.3v319.7zM211.2 202c-4.2 4.2-4.3 11 0 15.2l74.1 74.7c4.2 4.3 11 4.3 15.2 0.1l128.3-127.2c4.3-4.2 4.3-11 0.1-15.2l-25.3-25.5c-4.2-4.3-11-4.3-15.2-0.1l-95.2 94.4-41.3-41.6c-4.2-4.3-11-4.3-15.2-0.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/vote-yea.js
// module id = 2099
// module chunks = 0